import { createContext, MutableRefObject, PropsWithChildren, Ref, useContext } from 'react';

import { IPage } from 'utils/itineraryDetails/types';

import { IPageConfig } from './types';

export interface IPageContext {
  // config: ILandingConfig;
  // eslint-disable-next-line no-undef
  data: IPage;
  readonly: boolean;
  activeBlockId?: number;
  setActiveBlockId?: (pageId: number) => void;
  onSetActiveBlockId?: (pageId: number) => void;
  leftSideRef: MutableRefObject<HTMLDivElement | null>;
  rightSideRef: Ref<HTMLDivElement>;
  pageHeadlineRef: MutableRefObject<HTMLDivElement | null>;
  onChange?: (data: Partial<IPage>) => void;
  onChangeCoverImage?: () => void;
  index: number;
  config: IPageConfig;
  virtualized?: {
    rendered?: boolean;
    height?: number;
  };
}

const PageContext = createContext<IPageContext>({
  data: {} as IPage,
  readonly: true,
  // config: landingConfig,
  leftSideRef: { current: null },
  rightSideRef: { current: null },
  pageHeadlineRef: { current: null },
  onChange: () => {},
  onChangeCoverImage: () => {},
  index: 0,
  config: {} as IPageConfig,
});
export const usePageContext = () => useContext(PageContext);

interface IPageContextProviderProps extends PropsWithChildren {
  value: IPageContext;
}

export const PageContextProvider = ({ value, children }: IPageContextProviderProps) => {
  return <PageContext.Provider value={value}>{children}</PageContext.Provider>;
};
